




































































































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import Number from "@/shared/filters/Number.ts";
import ConfirmDialog from "@/components/common/ConfirmDialog.vue";
import { UserService } from "@/service/UserService";
import loadingService from "@/service/loadingService";
import UserFooter from "@/components/UserFooter.vue";
import { MESSAGE } from "@/model/Message";
import TopBarTitle from "@/components/common/TopBarTitle.vue";
import InputNumber from "@/components/common/input/InputNumber.vue";
import OptionPage from "@/page/user/OptionPage.vue";
@Component({
  filters: {
    Number
  },
  components: {
    ConfirmDialog,
    UserFooter,
    TopBarTitle,
    InputNumber
  }
})
export default class QuickOptionComponent extends OptionPage {

/** 2023-10-20 一時的な対応：簡単見積機能を税込税抜切り替え対象から外す [START] */
  @Prop() modeQuick: boolean;
  excludingFlg: boolean = false;
  excludingTex: string = "";
  loadingService: loadingService = new loadingService();

  mounted() {
    this.$emit("onActiveSideTab", 5);
    if(this.modeQuick){
      this.excludingFlg = false;
      this.excludingTex = "税込";
    }else{
      if( this.isExcludingTax ) this.excludingFlg = true;
      this.excludingTex = this.taxLabel;
    }
  }
/** 2023-10-20 一時的な対応：簡単見積機能を税込税抜切り替え対象から外す [END] */

  onClickEdit(isEdit: boolean) {
    this.isEditPrice = isEdit;
    if (!this.isEditPrice) {
      this.onConfirm(0);
      this.onCheckChange();
    }
  }

  onConfirm(isConfirm: number) {
    if (this.optionData) {
      if (this.optionData.option && this.optionData.option.items) {
        this.optionData.option.subTotalZk = this.subTotalZk;
        this.optionData.option.subTotalZn = this.subTotalZn;
      }
      this.setOption(this.optionData);
      let _isConfirm: any = isConfirm;
      if (isConfirm == 0) {
        _isConfirm = this.optionData.isConfirm;
      }
      if (this.optionDataForSave.option) {
        this.loadingService.show();
        this.reqService.saveOption({
          options: this.optionDataForSave.option.items
          , sknUketsukeUserJouhou: { isConfirmOption: _isConfirm }
          , sknUketsukeExtendsId: this.uketsukeExtendsId
        }).then((res: any) => {
          /** 2021-07-14 sh #7131 it get option from server after save.(quick mitsumori) [START] */
          // 手動で追加したオプションにIDが保持されないので、保存した後、再読み込みをする。
          // this.confirm(_isConfirm);
          const userService = new UserService();
          let promise = userService.getOptionPM();
          Promise.all([promise]).then(() => {
            this.loadingService.hide();
            this.confirm(_isConfirm);
            /** 2024-10-30 オプションの保存と読込の順序が入替わらぬよう処理分解 [START] */
            this.$emit("closeNext");
            /** 2024-10-30 オプションの保存と読込の順序が入替わらぬよう処理分解 [END] */
          }, (err) => {
            // ローディングだけは、止めておく
            this.loadingService.hide();
            /** 2024-10-30 オプションの保存と読込の順序が入替わらぬよう処理分解 [START] */
            this.$emit("closeNext");
            /** 2024-10-30 オプションの保存と読込の順序が入替わらぬよう処理分解 [END] */
          });
          /** 2021-07-14 sh #7131 it get option from server after save.(quick mitsumori) [END] */
        }, error => {
          this.loadingService.hide();
          this.$notify.error({
            title: "エラー",
            message: MESSAGE.SystemError
          });
          /** 2024-10-30 オプションの保存と読込の順序が入替わらぬよう処理分解 [START] */
          this.$emit("closeNext");
          /** 2024-10-30 オプションの保存と読込の順序が入替わらぬよう処理分解 [END] */
        });
      } else {
        this.confirm(_isConfirm);
        /** 2024-10-30 オプションの保存と読込の順序が入替わらぬよう処理分解 [START] */
        this.$emit("closeNext");
        /** 2024-10-30 オプションの保存と読込の順序が入替わらぬよう処理分解 [END] */
      }
    }
  }
}
